// 사용자 주문 API 래퍼.
// 모든 응답은 envelope { ok, order(s) } 형태이며 내용을 풀어 반환한다.
// 에러는 client.ts 의 ApiError 로 정규화되어 올라오므로, 화면에서 code/message 로 분기한다.

import type { CreateOrderInput, OrderDto, OrderStatus } from "@oo/shared";
import { api } from "@/api/client.ts";

// 주문 생성. 항목/금액은 서버가 본인 카트에서 재구성하므로 본 입력에는 담지 않는다.
export async function createOrder(input: CreateOrderInput): Promise<OrderDto> {
  const data = await api.post<{ order: OrderDto }>("/orders", input);
  return data.order;
}

// 본인 주문 목록. status 가 주어지면 해당 상태만.
export async function listOrders(status?: OrderStatus): Promise<OrderDto[]> {
  const path = status ? `/orders?status=${encodeURIComponent(status)}` : "/orders";
  const data = await api.get<{ orders: OrderDto[] }>(path);
  return data.orders;
}

// 본인 주문 단건.
export async function getOrder(id: string): Promise<OrderDto> {
  const data = await api.get<{ order: OrderDto }>(`/orders/${id}`);
  return data.order;
}

// 본인 주문 취소 (received 단계에서만 서버가 허용).
export async function cancelOrder(id: string): Promise<OrderDto> {
  const data = await api.post<{ order: OrderDto }>(`/orders/${id}/cancel`);
  return data.order;
}

// 일반(즉시) 카드결제 확인. 손님이 결제창에서 결제를 마친 뒤 호출한다(서버가 포트원으로 검증).
//  - 아직 결제 전이면 서버가 409(paymentError='not_paid')로 응답하므로 화면에서 재시도를 안내한다.
export async function confirmDirectPayment(id: string): Promise<OrderDto> {
  const data = await api.post<{ order: OrderDto }>(`/orders/${id}/payment/confirm-direct`);
  return data.order;
}
